import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import CheckboxList, { FilterListItem } from '../../CheckboxList';
import { accessService } from '../../../../services/central-api/access';
import { translate } from '../../../../services/translate';
import FilterDependencyMessage from '../../../Filters/FilterDependencyMessage';

function DownloadActingBodyUnitsList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name, actingBodyId }: { name: TName; actingBodyId: number; }) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let active = true;
        if (!actingBodyId) {
            setItems([]);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        accessService.getActingBody(actingBodyId)
            .then(body => {
                if (active) {
                    setItems((body.actingBodyUnits ?? []).map(unit => ({ label: unit.name, value: unit.id || 0 })));
                }
            })
            .catch(error => console.error(error))
            .finally(() => {
                if (active) {
                    setIsLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [actingBodyId]);

    if (!actingBodyId) {
        return <FilterDependencyMessage message={translate('selectActingBodyFirst')} />;
    }

    return <CheckboxList name={name} items={items} isLoading={isLoading} />;
}

DownloadActingBodyUnitsList.getCount = CheckboxList.getCount;

export default DownloadActingBodyUnitsList;
